// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const AwsS3BucketsIcon = createSvgIcon(
  <svg width={40} height={40} fill="none" viewBox="0 0 40 40">
    <path fill="url(#aws-s3-buckets_svga)" d="M40 0H0v40h40z" />
    <svg width={27} height={28} x={6.5} y={6} viewBox="0 0 27 28">
      <path
        fill="#fff"
        fillRule="evenodd"
        d="m23.84 15.34.14-1.05a5 5 0 0 1 1.58 1.25c-.19.04-.66.06-1.72-.2m-2.54 9.32v.08c0 .1-.25.48-1.32.9q-.71.29-1.67.5c-1.64.38-3.65.59-5.67.59-5.38 0-8.64-1.38-8.64-1.99l-.01-.08L1.55 6.54l.5.26.15.07.49.2.2.09.57.2q.08.01.15.04l.75.22.2.05.63.15.26.06.72.14q.08 0 .14.03l.9.14.25.03.7.1.29.02q.42.05.86.09h.1l.96.07.28.02.73.03h.29a39 39 0 0 0 2.97-.03l.27-.02.97-.06.1-.01q.44-.04.86-.09.15 0 .28-.03.36-.03.71-.09l.25-.03.9-.14.13-.03.74-.14.24-.06.64-.15.2-.05.76-.22.13-.04.58-.2.2-.08.5-.22.13-.06q.27-.12.51-.26l-1.14 8.45a79 79 0 0 1-8.53-3.5 1.27 1.27 0 1 0-1.27 1.27q.34 0 .63-.17c2 .95 6 2.76 9 3.67zM12.64 1.27c6.63 0 11.3 2.05 11.38 3.2l-.02.12q-.01.06-.05.12-.02.05-.06.1l-.1.12-.1.1-.16.13q-.05.05-.14.1l-.2.13-.18.1-.26.13-.2.1-.32.13-.23.1-.36.12-.27.1-.4.11-.3.09-.46.11-.32.08-.5.11-.35.07-.56.1-.35.06-.6.08-.38.05-.66.07-.38.05-.68.05-.42.03-.75.03-.41.02a42 42 0 0 1-2.41 0l-.41-.02-.75-.03-.42-.03-.68-.05-.38-.05-.66-.07-.37-.05-.6-.08-.35-.06-.57-.1-.33-.07-.52-.1-.3-.08-.48-.12-.27-.08q-.23-.06-.43-.13l-.25-.08-.38-.13-.22-.1-.33-.13-.2-.1-.26-.13-.17-.1-.22-.13-.13-.1-.16-.12-.1-.1-.1-.13q-.04-.05-.05-.1l-.06-.12-.02-.13c.09-1.14 4.75-3.19 11.37-3.19m14.22 14.14c-.14-.73-.98-1.5-2.7-2.48l1.1-8.1.02-.25.01-.09C25.29 1.85 18.63 0 12.64 0S0 1.85 0 4.5v.08l.04.24L2.73 24.8C2.8 27.13 8.83 28 12.64 28c2.1 0 4.22-.22 5.95-.62q1.05-.24 1.86-.56 2.07-.82 2.11-2.03l1.1-8.19q.99.23 1.63.23.93 0 1.32-.48.33-.41.25-.94"
        clipRule="evenodd"
      />
    </svg>
    <defs>
      <linearGradient
        id="aws-s3-buckets_svga"
        x1={0}
        x2={40.99}
        y1={0}
        y2={38.96}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "AwsS3Buckets",
);
export default AwsS3BucketsIcon;
